import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
    AppBar,
    Box,
    Button,
    Container,
    Paper,
    Stack,
    Toolbar,
    Typography,
} from '@mui/material';
import SiteFooter, { FooterCta } from '../components/landing/SiteFooter';

const HEADER_HEIGHT = 88;

function NotFoundPage() {
    const handleRegisterClick = () => {
        window.location.href = '/vhod/';
    };

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#F5F7FA' }}>
            <Helmet defer={false}>
                <title>Страница не найдена | ФинРадар</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.92)',
                    color: '#101828',
                    borderBottom: '1px solid #EAECF0',
                    backdropFilter: 'blur(16px)',
                }}
            >
                <Container maxWidth="xl">
                    <Toolbar disableGutters sx={{ minHeight: `${HEADER_HEIGHT}px`, gap: 2 }}>
                        <Box component={RouterLink} to="/" sx={{ textDecoration: 'none', flexGrow: 1 }}>
                            <Typography sx={{ fontWeight: 800, color: '#0F172A' }}>
                                ФинРадар
                            </Typography>
                        </Box>
                        <Button
                            component={RouterLink}
                            to="/vhod/"
                            sx={{ textTransform: 'none', fontWeight: 700 }}
                        >
                            Войти
                        </Button>
                    </Toolbar>
                </Container>
            </AppBar>

            <Container maxWidth="md" sx={{ py: { xs: 7, md: 12 } }}>
                <Paper
                    elevation={0}
                    sx={{
                        p: { xs: 3, md: 5 },
                        border: '1px solid #EAECF0',
                        borderRadius: 2,
                        backgroundColor: '#FFFFFF',
                    }}
                >
                    <Stack spacing={2.5} alignItems="flex-start">
                        <Typography sx={{ color: '#155EEF', fontWeight: 800 }}>
                            404
                        </Typography>
                        <Typography component="h1" sx={{ fontSize: { xs: 34, md: 48 }, fontWeight: 800, lineHeight: 1.08 }}>
                            Страница не найдена
                        </Typography>
                        <Typography sx={{ color: '#475467', fontSize: 18, lineHeight: 1.7 }}>
                            Возможно, адрес изменился или в ссылке есть ошибка.
                        </Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
                            <Button
                                component={RouterLink}
                                to="/"
                                variant="contained"
                                sx={{ textTransform: 'none', fontWeight: 700 }}
                            >
                                На главную
                            </Button>
                            <Button
                                component={RouterLink}
                                to="/vhod/"
                                variant="outlined"
                                sx={{ textTransform: 'none', fontWeight: 700 }}
                            >
                                Войти
                            </Button>
                        </Stack>
                    </Stack>
                </Paper>
            </Container>

            <FooterCta onRegisterClick={handleRegisterClick} />
            <SiteFooter onRegisterClick={handleRegisterClick} />
        </Box>
    );
}

export default NotFoundPage;
